import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="container">
        <div className="privacy-content">
          <h1>Политика конфиденциальности</h1>
          <div className="privacy-date privacy-date--top">
            <p>Дата публикации: 20.11.2025</p>
            <p>Текущая версия доступна по адресу: https://belaya-hotel.ru/privacy-policy</p>
          </div>

          <div className="privacy-section">
            <h2>1. Общие положения</h2>
            <p>
              Настоящая политика конфиденциальности (далее — Политика) действует в отношении всей информации, 
              включая персональные данные в понимании применимого законодательства (далее — «Персональная информация»), 
              которую ООО «УРАЛ» (далее — «Оператор») может получить о Вас в процессе использования Вами сайта 
              belaya-hotel.ru (далее — «Сайт»), программ, продуктов и/или сервисов гостиницы "Белая".
            </p>
            <p>
              Политика разработана во исполнение требований Федерального закона от 27.07.2006 N 152-ФЗ 
              «О персональных данных» в целях обеспечения защиты прав и свобод человека и гражданина при 
              обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, 
              личную и семейную тайну.
            </p>
          </div>

          <div className="privacy-section">
            <h2>2. Основные понятия</h2>
            <p><strong>Персональные данные</strong> — любая информация, относящаяся к прямо или косвенно определенному 
            или определяемому физическому лицу (субъекту персональных данных).</p>
            
            <p><strong>Обработка персональных данных</strong> — любое действие (операция) или совокупность действий 
            (операций) с персональными данными, совершаемых с использованием средств автоматизации или без их использования. 
            Обработка включает в себя: сбор, запись, систематизацию, накопление, хранение, уточнение, использование, 
            передачу, обезличивание, блокирование, удаление, уничтожение.</p>
            
            <p><strong>Автоматизированная обработка персональных данных</strong> – обработка персональных данных 
            с помощью средств вычислительной техники.</p>
            
            <p><strong>Оператор персональных данных</strong> — государственный орган, муниципальный орган, юридическое 
            или физическое лицо, самостоятельно или совместно с другими лицами организующие и (или) осуществляющие 
            обработку персональных данных.</p>
          </div>

          <div className="privacy-section">
            <h2>3. Кто обрабатывает информацию</h2>
            <p>
              Для обеспечения использования Вами Сайта и услуг гостиницы Ваша Персональная информация собирается 
              и используется ООО «УРАЛ», юридическим лицом, созданным по законодательству Российской Федерации.
            </p>
            <p>
              По всем вопросам, связанным с обработкой персональных данных, вы можете обращаться:
            </p>
            <ul>
              <li><strong>Телефон:</strong> +7(987)13-29-881</li>
              <li><strong>Организация:</strong> ООО «УРАЛ»</li>
              <li><strong>Email:</strong> oooural@internet.ru</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>4. Цели обработки персональных данных</h2>
            <p>
              Обработка персональных данных ограничивается достижением конкретных, заранее определенных и законных целей. 
              Не допускается обработка персональных данных, несовместимая с целями сбора персональных данных.
            </p>
            <p>Обработка Оператором персональных данных осуществляется в следующих целях:</p>
            <ul>
              <li>Обработки запросов и бронирования номеров</li>
              <li>Оказания услуг миграционного учета</li>
              <li>Связи с пользователями по предоставленным контактам</li>
              <li>Улучшения качества предоставляемых услуг</li>
              <li>Заключения и исполнения договоров с клиентами</li>
              <li>Осуществления пропускного режима</li>
              <li>Соблюдения требований законодательства Российской Федерации</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>5. Правовые основания обработки персональных данных</h2>
            <p>
              Оператор обрабатывает Вашу Персональную информацию только в том случае, если:
            </p>
            <ul>
              <li>обработка необходима для выполнения договоров между Вами и Оператором;</li>
              <li>обработка необходима для соблюдения установленных законодательством обязательств;</li>
              <li>обработка осуществляется с Вашего согласия на обработку персональных данных.</li>
            </ul>
            <p>
              Правовым основанием обработки персональных данных является совокупность нормативных правовых актов, 
              во исполнение которых и в соответствии с которыми Оператор осуществляет обработку персональных данных.
            </p>
          </div>

          <div className="privacy-section">
            <h2>6. Объем обрабатываемых персональных данных</h2>
            <p>Оператор может обрабатывать следующие персональные данные:</p>
            <ul>
              <li>Фамилия, имя, отчество</li>
              <li>Контактные данные (телефон, email)</li>
              <li>Данные документов, удостоверяющих личность</li>
              <li>Информация о геолокации (при использовании услуг)</li>
              <li>Дата и время осуществления доступа к Сайту</li>
              <li>Информация о Вашей активности во время использования Сайта</li>
              <li>Иные персональные данные, необходимые для оказания услуг</li>
            </ul>
            <p>
              Оператором не осуществляется обработка специальных категорий персональных данных, касающихся 
              расовой, национальной принадлежности, политических взглядов, религиозных или философских убеждений, 
              состояния здоровья, интимной жизни, за исключением случаев, предусмотренных законодательством РФ.
            </p>
          </div>

          <div className="privacy-section">
            <h2>7. Порядок и условия обработки персональных данных</h2>
            <p>
              Обработка персональных данных осуществляется с согласия субъектов персональных данных на обработку 
              их персональных данных, а также без такового в случаях, предусмотренных законодательством Российской Федерации.
            </p>
            <p>
              Оператор осуществляет обработку персональных данных следующими способами:
            </p>
            <ul>
              <li>неавтоматизированная обработка персональных данных;</li>
              <li>автоматизированная обработка персональных данных;</li>
              <li>смешанная обработка персональных данных.</li>
            </ul>
            <p>
              Оператор принимает необходимые правовые, организационные и технические меры для защиты персональных данных 
              от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, распространения 
              и других несанкционированных действий.
            </p>
            <p>
              Оператор осуществляет хранение персональных данных в форме, позволяющей определить субъекта персональных данных, 
              не дольше, чем этого требуют цели обработки персональных данных.
            </p>
          </div>

          <div className="privacy-section">
            <h2>8. Передача персональных данных</h2>
            <p>
              Не допускается раскрытие третьим лицам и распространение персональных данных без согласия субъекта 
              персональных данных, если иное не предусмотрено федеральным законом.
            </p>
            <p>
              Оператор может передавать Персональную информацию:
            </p>
            <ul>
              <li>в органы дознания и следствия, Федеральную налоговую службу, Социальный фонд России и другие 
                  уполномоченные органы исполнительной власти в соответствии с требованиями законодательства;</li>
              <li>партнерам, участвующим в оказании услуг (службы такси, экскурсионные службы и т.д.);</li>
              <li>лицам, участвующим в организации приема платежей и проведении платежных операций.</li>
            </ul>
            <p>
              Оператор осуществляет запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), 
              извлечение персональных данных граждан Российской Федерации с использованием баз данных, находящихся 
              на территории Российской Федерации.
            </p>
          </div>

          <div className="privacy-section">
            <h2>9. Сроки хранения персональных данных</h2>
            <p>
              Оператор будет хранить Вашу Персональную информацию столько времени, сколько это необходимо для 
              достижения цели, для которой она была собрана, или для соблюдения требований законодательства и нормативных актов.
            </p>
            <p>
              Оператор прекращает обработку персональных данных в следующих случаях:
            </p>
            <ul>
              <li>выявлен факт их неправомерной обработки;</li>
              <li>достигнута цель их обработки;</li>
              <li>истек срок действия или отозвано согласие субъекта персональных данных.</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>10. Права субъектов персональных данных</h2>
            <p>Субъект персональных данных имеет право:</p>
            <ul>
              <li>получать информацию, касающуюся обработки его персональных данных;</li>
              <li>требовать от оператора уточнения его персональных данных, их блокирования или уничтожения;</li>
              <li>отзывать согласие на обработку персональных данных;</li>
              <li>обжаловать действия или бездействие Оператора в уполномоченном органе или в судебном порядке;</li>
              <li>на доступ к своей Персональной информации, включая получение копии персональных данных.</li>
            </ul>
            <p>
              Для осуществления указанных прав необходимо обратиться к Оператору по контактным данным, 
              указанным в разделе 3 настоящей Политики.
            </p>
          </div>

          <div className="privacy-section">
            <h2>11. Использование файлов cookie</h2>
            <p>
              Сайт использует файлы cookie и аналогичные технологии для обеспечения работы Сайта, 
              сбора статистической информации и улучшения качества предоставляемых услуг.
            </p>
            <p>
              Файлы cookie — это небольшие фрагменты данных, которые принимаются и обрабатываются устройством, 
              которое Вы используете для доступа к Сайту. Они помогают запоминать Ваши предпочтения и настройки.
            </p>
            <p>
              Вы можете изменить настройки Вашего браузера, чтобы принимать или отклонять файлы cookie. 
              Если Вы отказываетесь от использования файлов cookie, это может повлиять на возможность 
              использования Вами некоторых функций Сайта.
            </p>
          </div>

          <div className="privacy-section">
            <h2>12. Ответственность</h2>
            <p>
              Ответственность за нарушение требований законодательства Российской Федерации в сфере обработки 
              и защиты персональных данных определяется в соответствии с законодательством Российской Федерации.
            </p>
            <p>
              Контроль за исполнением требований настоящей Политики осуществляется уполномоченным лицом, 
              ответственным за организацию обработки персональных данных у Оператора.
            </p>
          </div>

          <div className="privacy-section">
            <h2>13. Изменения в Политике конфиденциальности</h2>
            <p>
              В настоящую Политику могут быть внесены изменения. Оператор уведомит Вас о существенных 
              изменениях путем размещения новой версии Политики на Сайте.
            </p>
            <p>
              При внесении изменений в заголовке Политики указывается дата последнего обновления редакции. 
              Новая редакция Политики вступает в силу с момента ее размещения на Сайте.
            </p>
          </div>

          <div className="privacy-date">
            <p>Дата последнего обновления: 20.11.2025</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;